import { render } from "./App.vue?vue&type=template&id=d7f232ae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d7f232ae&lang=scss"

import exportComponent from "/Users/ethan/Desktop/zixel/zetaverseDev/zetaverseweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__